webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(15);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(11);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (true) {
  __webpack_require__(4);
}
// @ is the path to `./src` folder


new _vue2.default({
  el: '#app',
  render: function render(h) {
    return h(_App2.default);
  }
});

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * (c) 2016-2017 WASD-ORG
 * Released under the MIT License.
 */
(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : factory(global.WASD_Tetris = global.WASD_Tetris || {});
})(undefined, function (exports) {
  'use strict';

  function extend(to, from) {
    if (to === void 0) to = {};
    if (from === void 0) from = {};

    for (var key in from) {
      to[key] = from[key];
    }
    return to;
  }

  function pick(object) {
    var array = Object.keys(object);
    var index = Math.floor(Math.random() * array.length);

    return object[array[index]];
  }

  function transpose(array) {
    var row = array.length;
    var col = array[0].length;

    if (!row || !col) {
      return array;
    }

    var ret = [];

    for (var i = 0; i < col; i++) {
      ret.push([]);
      for (var j = 0; j < row; j++) {
        ret[i][j] = array[j][i];
      }
    }

    return ret;
  }

  function copy(array) {
    return array.map(function (a) {
      return a.slice();
    });
  }

  function reverseRow(array) {
    return copy(array).map(function (a) {
      return a.reverse();
    });
  }

  function reverseCol(array) {
    return copy(array).reverse();
  }

  function rotate(array, clockwise) {
    if (clockwise === void 0) clockwise = true;

    var transposed = transpose(array);
    if (clockwise) {
      return reverseRow(transposed);
    } else {
      return reverseCol(transposed);
    }
  }

  // export function equal (a, b) {
  //   const aLength = a.length
  //   const bLength = b.length

  //   if (aLength !== bLength) {
  //     return false
  //   }

  //   for (let i = 0; i < aLength; i++) {
  //     const aArray = a[i]
  //     const bArray = b[i]

  //     const aArrayLength = aArray.length
  //     const bArrayLength = bArray.length

  //     if (aArrayLength !== bArrayLength) {
  //       return false
  //     }

  //     for (let j = 0; j < aArrayLength; j++) {
  //       if (aArray[j] !== bArray[j]) {
  //         return false
  //       }
  //     }
  //   }

  //   return true
  // }

  function equal(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  function create(row, col, fill) {
    if (fill === void 0) fill = 0;

    var ret = [];

    for (var i = 0; i < row; i++) {
      ret.push([]);

      for (var j = 0; j < col; j++) {
        ret[i].push(fill);
      }
    }

    return ret;
  }

  function slice(ref) {
    var array = ref.array;
    var startRow = ref.startRow;
    var endRow = ref.endRow;
    var startCol = ref.startCol;
    var endCol = ref.endCol;

    var row = array.length;
    var col = array[0].length;
    if (!row || !col) {
      return;
    }

    startRow = Math.min(Math.max(0, startRow), row);
    startCol = Math.min(Math.max(0, startCol), col);
    endRow = Math.min(Math.max(0, endRow), row);
    endCol = Math.min(Math.max(0, endCol), col);

    var ret = [];

    for (var i = 0, rowLength = endRow - startRow; i < rowLength; i++) {
      ret.push([]);
      for (var j = 0, colLength = endCol - startCol; j < colLength; j++) {
        ret[i].push(array[i + startRow][j + startCol]);
      }
    }

    return ret;
  }

  function padStart(array, targetLength, pad) {
    if (targetLength === void 0) targetLength = 0;
    if (pad === void 0) pad = 0;

    var length = array.length;

    if (length > targetLength) {
      return array.slice();
    }

    var extra = Array(targetLength - length).fill(pad);

    return extra.concat(array);
  }

  function padEnd(array, targetLength, pad) {
    if (pad === void 0) pad = 0;

    var length = array.length;

    if (length > targetLength) {
      return array.slice();
    }

    var extra = Array(targetLength - length).fill(pad);

    return array.concat(extra);
  }

  function shift(array, offset, pad) {
    if (offset === void 0) offset = 0;
    if (pad === void 0) pad = 0;

    var length = array.length;
    if (offset >= 0) {
      return padEnd(array, length + offset, pad);
    }

    var count = -offset;

    if (count > length) {
      return [];
    }

    return array.slice(0, length - count);
  }

  function intersect$1(a, b) {
    var aLength = a.length;
    var bLength = b.length;
    var offset = aLength - bLength;

    var newA = a.slice();
    var newB = b.slice();

    if (offset > 0) {
      newB = padStart(newB, aLength);
    } else if (offset < 0) {
      newA = padStart(newA, bLength);
    }

    for (var i = 0, l = newA.length; i < l; i++) {
      if (newA[i] && newB[i]) {
        return true;
      }
    }

    return false;
  }

  function union(a, b) {
    var aLength = a.length;
    var bLength = b.length;
    var offset = aLength - bLength;

    var newA = a.slice();
    var newB = b.slice();

    if (offset > 0) {
      newB = padStart(newB, aLength);
    } else if (offset < 0) {
      newA = padStart(newA, bLength);
    }

    var ret = [];

    for (var i = 0, l = newA.length; i < l; i++) {
      ret[i] = newB[i] || newA[i];
    }

    return ret;
  }

  function intersect$$1(a, b) {
    var length = Math.min(a.length, b.length);
    for (var i = 0, l = length; i < l; i++) {
      if (intersect$1(a[i], b[i])) {
        return true;
      }
    }

    return false;
  }

  function shift$1(array, offset, fill) {
    if (offset === void 0) offset = 0;
    if (fill === void 0) fill = 0;

    return array.map(function (a) {
      return shift(a, offset, fill);
    });
  }

  function padTop(array, length, fill) {
    if (fill === void 0) fill = 0;

    array = copy(array);
    var l = array.length;
    if (!l) {
      return array;
    }
    var row = length - l;
    var col = array[0].length;

    if (row <= 0 || col <= 0) {
      return array;
    }

    return create(row, col, fill).concat(array);
  }

  function union$1(a, b) {
    var ret = copy(a);

    for (var i = 0, l = Math.min(a.length, b.length); i < l; i++) {
      ret[i] = union(a[i], b[i]);
    }

    return ret;
  }

  var Matrix = function Matrix(options) {
    this._options = extend({
      row: 20,
      col: 10,
      x: 0,
      y: 0
    }, options);

    this.x = this._options.x;
    this.y = this._options.y;
    this.row = this._options.row;
    this.col = this._options.col;

    this.reset();
  };

  var prototypeAccessors$1 = { coordinate: {} };

  prototypeAccessors$1.coordinate.get = function () {
    return {
      x: this.x,
      y: this.y,
      array: this.matrix
    };
  };

  Matrix.prototype.reset = function reset() {
    this.matrix = create(this.row, this.col);
  };

  Object.defineProperties(Matrix.prototype, prototypeAccessors$1);

  function slice$1(ref) {
    var block = ref.block;
    var startX = ref.startX;
    var endX = ref.endX;
    var startY = ref.startY;
    var endY = ref.endY;

    var x = block.x;
    var y = block.y;
    var array = block.array;

    var startCol = startX - x;
    var endCol = endX - x;
    var startRow = startY - y;
    var endRow = endY - y;

    return {
      array: slice({ array: array, startCol: startCol, endCol: endCol, startRow: startRow, endRow: endRow }),
      x: x,
      y: y
    };
  }

  function intersect$2(a, b) {
    var ax = a.x;
    var ay = a.y;
    var aArray = a.array;
    var aRow = aArray.length;
    var aCol = aArray[0].length;
    var aStartX = ax;
    var aEndX = aStartX + aCol;
    var aStartY = ay;
    var aEndY = aStartY + aRow;

    var bx = b.x;
    var by = b.y;
    var bArray = b.array;
    var bRow = bArray.length;
    var bCol = bArray[0].length;
    var bStartX = bx;
    var bEndX = bStartX + bCol;
    var bStartY = by;
    var bEndY = bStartY + bRow;

    if (aEndX < bStartX || aEndY < bStartY) {
      return false;
    }
    if (aStartX > bEndX || aStartY > bEndY) {
      return false;
    }

    var startX = Math.max(aStartX, bStartX);
    var startY = Math.max(aStartY, bStartY);
    var endX = Math.min(aEndX, bEndX);
    var endY = Math.min(aEndY, bEndY);

    var slicedA = slice$1({
      block: a,
      startX: startX,
      endX: endX,
      startY: startY,
      endY: endY
    });

    var slicedB = slice$1({
      block: b,
      startX: startX,
      endX: endX,
      startY: startY,
      endY: endY
    });

    return intersect$$1(slicedA.array, slicedB.array);
  }

  function union$2(a, b) {
    var ax = a.x;
    var ay = a.y;
    var aArray = a.array;
    var aRow = aArray.length;
    var aCol = aArray[0].length;
    var aStartX = ax;
    var aEndX = aStartX + aCol;
    var aStartY = ay;
    var aEndY = aStartY + aRow;

    var bx = b.x;
    var by = b.y;
    var bArray = b.array;
    var bRow = bArray.length;
    var bCol = bArray[0].length;
    var bStartX = bx;
    var bEndX = bStartX + bCol;
    var bStartY = by;
    var bEndY = bStartY + bRow;

    if (aEndX < bStartX || aEndY < bStartY) {
      return a;
    }
    if (aStartX > bEndX || aStartY > bEndY) {
      return a;
    }

    var startX = Math.max(aStartX, bStartX);
    var startY = Math.max(aStartY, bStartY);
    var endX = Math.min(aEndX, bEndX);
    var endY = Math.min(aEndY, bEndY);

    var slicedA = slice$1({
      block: a,
      startX: aStartX,
      endX: aEndX,
      startY: startY,
      endY: endY
    });

    var slicedB = slice$1({
      block: b,
      startX: startX,
      endX: endX,
      startY: startY,
      endY: endY
    });

    var unionedArray = union$1(slicedA.array, shift$1(slicedB.array, aEndX - endX));

    var ret = copy(aArray);

    ret.splice.apply(ret, [startY, endY - startY].concat(unionedArray));

    return {
      array: ret,
      x: aStartX,
      y: aStartY
    };
  }

  var Shape = function Shape(shape) {
    if (shape === void 0) shape = [];

    this._shape = shape;
    this._index = 0;

    this.maxCol = this.maxRow = shape.length;

    this._init();
  };

  var prototypeAccessors$3 = { shape: {}, index: {}, margin: {} };

  Shape.prototype.clone = function clone() {
    return new Shape(this._shape);
  };

  prototypeAccessors$3.shape.get = function () {
    return this._shapes[this._index];
  };

  prototypeAccessors$3.index.get = function () {
    return this._index;
  };

  prototypeAccessors$3.index.set = function (val) {
    this._index = val;
  };

  prototypeAccessors$3.margin.get = function () {
    var gutter = Array(this.maxCol).fill(0).join("");
    var shape = this.shape;

    var check = function check(array) {
      var start = 0;
      var block = 0;
      var end = 0;

      array.map(function (a) {
        return a.join("");
      }).forEach(function (a) {
        if (a === gutter) {
          if (!block) {
            start++;
          } else {
            end++;
          }
        } else {
          block++;
        }
      });

      return {
        start: start,
        block: block,
        end: end
      };
    };

    var ref = check(shape);
    var top = ref.start;
    var row = ref.block;
    var bottom = ref.end;
    var ref$1 = check(rotate(shape));
    var left = ref$1.start;
    var col = ref$1.block;
    var right = ref$1.end;

    return {
      top: top,
      row: row,
      bottom: bottom,

      left: left,
      col: col,
      right: right
    };
  };

  Shape.prototype.rotate = function rotate$$1(clockwise) {
    if (clockwise === void 0) clockwise = true;

    if (clockwise) {
      this._index++;
    } else {
      this._index--;
    }

    var length = this._shapes.length;
    if (this._index < 0) {
      this._index = length - 1;
    }

    if (this._index >= length) {
      this._index = 0;
    }

    return this.shape;
  };

  Shape.prototype._init = function _init() {
    var ref = this;
    var shape = ref._shape;
    var shapes = [shape];
    var lastShape = shape;

    while (true) {
      lastShape = rotate(lastShape);
      if (equal(lastShape, shape)) {
        break;
      } else {
        shapes.push(lastShape);
      }
    }

    this._shapes = shapes;
  };

  Object.defineProperties(Shape.prototype, prototypeAccessors$3);

  var shapes = {
    I: [[0, 0, 0, 0], [0, 0, 0, 0], [1, 1, 1, 1], [0, 0, 0, 0]],

    J: [[0, 0, 0], [1, 1, 1], [0, 0, 1]],

    L: [[0, 0, 0], [1, 1, 1], [1, 0, 0]],

    O: [[1, 1], [1, 1]],

    S: [[0, 0, 0], [0, 1, 1], [1, 1, 0]],

    T: [[0, 0, 0], [1, 1, 1], [0, 1, 0]],

    Z: [[0, 0, 0], [1, 1, 0], [0, 1, 1]]
  };

  var _ = {};

  for (var key in shapes) {
    _[key] = new Shape(shapes[key]);
  }

  function create$1(type) {
    if (!type) {
      return pick(_);
    } else {
      return _[type].clone();
    }
  }

  var Block = function Block(options) {
    this._options = extend({
      x: 0,
      y: 0,
      shape: create$1()
    }, options);

    this.x = this._options.x;
    this.y = this._options.y;
    this.shape = this._options.shape;
  };

  var prototypeAccessors$2 = { coordinate: {} };

  prototypeAccessors$2.coordinate.get = function () {
    return {
      x: this.x,
      y: this.y,
      array: this.shape.shape
    };
  };

  Block.prototype.moveBy = function moveBy(x, y) {
    if (x === void 0) x = 0;
    if (y === void 0) y = 0;

    this.x += x;
    this.y += y;
  };

  Block.prototype.moveTo = function moveTo(x, y) {
    if (x === void 0) x = 0;
    if (y === void 0) y = 0;

    this.x = x;
    this.y = y;
  };

  Block.prototype.rotate = function rotate(clockwise) {
    if (clockwise === void 0) clockwise = true;

    this.shape.rotate(clockwise);
  };

  Object.defineProperties(Block.prototype, prototypeAccessors$2);

  var BlockMixin = function BlockMixin(Tetris) {
    var proto = Tetris.prototype;

    proto.drop = function () {
      if (this._failed || this._paused) {
        return false;
      }
      while (this.down()) {}
    };

    proto.down = function () {
      if (this._failed || this._paused) {
        return false;
      }
      this.save();
      this.block.moveBy(0, 1);
      if (this._detectCollision()) {
        this.restore();
        this.emit("hit");
        return false;
      } else {
        this.emit("repaint", this.graph);
        return true;
      }
    };

    proto.left = function () {
      if (this._failed || this._paused) {
        return false;
      }
      this.save();
      this.block.moveBy(-1, 0);
      if (this._detectCollision()) {
        this.restore();
        this.emit("overflow:left");
        return false;
      } else {
        this.emit("repaint", this.graph);
        return true;
      }
    };

    proto.right = function () {
      if (this._failed || this._paused) {
        return false;
      }
      this.save();
      this.block.moveBy(1, 0);
      if (this._detectCollision()) {
        this.restore();
        this.emit("overflow:right");
        return false;
      } else {
        this.emit("repaint", this.graph);
        return true;
      }
    };

    proto.rotate = function () {
      if (this._failed || this._paused) {
        return false;
      }
      this.save();
      this.block.rotate();
      if (this._detectCollision()) {
        this.restore();
        this.emit("hit:rotate");
        return false;
      } else {
        this.emit("repaint", this.graph);
        return true;
      }
    };

    proto.addBlock = function (block) {
      if (this._failed || this._paused) {
        return false;
      }

      if (!block) {
        block = new Block();
      }

      var ref = this.matrix;
      var col = ref.col;
      var row = ref.row;
      var ref$1 = block.shape;
      var margin = ref$1.margin;

      var x = Math.floor((col - margin.col) / 2) - margin.left;
      var y = 0 - margin.row - margin.top;

      block.moveTo(x, y);

      this.block = block;
    };
  };

  var LoopMixin = function LoopMixin(Tetris) {
    var proto = Tetris.prototype;

    proto.reset = function () {
      this.auto = this._options.auto;
      this.speed = this._options.speed;
      this.matrix = this._options.matrix;
      this.matrix.reset();

      this._paused = false;
      this._failed = false;

      this.addBlock();
      this.pause();
      this.resume();
      this.emit('repaint', this.graph);
    };

    proto.pause = function () {
      this._paused = true;
      if (this._timeout) {
        clearTimeout(this._timeout);
        this._timeout = null;
      }
    };

    proto.resume = function () {
      this._paused = false;
      if (!this._timeout) {
        this._process();
      }
    };

    proto.fail = function () {
      this._failed = true;
      this._paused = true;

      this.emit('repaint', this.graph);
      this.emit('failed');
    };

    proto.start = proto.reset;

    proto._process = function () {
      var instance = this;
      var ref = this;
      var auto = ref.auto;
      var speed = ref.speed;
      var loop = function loop() {
        if (auto && speed && !instance._paused) {
          instance._timeout = setTimeout(function () {
            instance.down();
            loop();
          }, speed);
        }
      };

      loop();
    };

    proto._next = function () {
      this._union();
      this._clearLines();
      this.addBlock();
    };
  };

  var EventsMixin = function EventsMixin(Tetris) {
    var proto = Tetris.prototype;

    proto.on = function (event, handler) {
      if (!this._events[event]) {
        this._events[event] = [];
      }

      this._events[event].push(handler);
    };

    proto.emit = function (event) {
      var args = [],
          len = arguments.length - 1;
      while (len-- > 0) {
        args[len] = arguments[len + 1];
      }var fns = this._events[event] || [];
      var instance = this;
      fns.forEach(function (fn) {
        fn.apply(instance, args);
      });
    };
  };

  var StateMixin = function StateMixin(Tetris) {
    var proto = Tetris.prototype;

    proto.save = function () {
      this._lastState = {
        matrix: {
          x: this.matrix.x,
          y: this.matrix.y,
          matrix: copy(this.matrix.matrix)
        },
        block: {
          x: this.block.x,
          y: this.block.y,
          index: this.block.shape.index
        }
      };
    };

    proto.restore = function () {
      var ref = this._lastState;
      var matrix = ref.matrix;
      var block = ref.block;

      this.matrix.x = matrix.x;
      this.matrix.y = matrix.y;
      this.matrix.matrix = copy(matrix.matrix);

      this.block.x = block.x;
      this.block.y = block.y;
      this.block.shape.index = block.index;
    };
  };

  var KeyboardMixin = function KeyboardMixin(Tetris) {
    var proto = Tetris.prototype;

    proto._bind = function () {
      var instance = this;
      document.addEventListener("keydown", function (e) {
        switch (e.which) {
          case 32:
            instance.drop();
            break;
          case 37:
            instance.left();
            break;
          case 38:
            instance.rotate();
            break;
          case 39:
            instance.right();
            break;
          case 40:
            instance.down();
            break;
          default:
            break;
        }
      });
    };
  };

  var MatrixMixin = function MatrixMixin(Tetris) {
    var proto = Tetris.prototype;

    proto._union = function () {
      this.matrix.matrix = union$2(this.matrix.coordinate, this.block.coordinate).array;
    };

    proto._clearLines = function () {
      var ref = this.matrix;
      var matrix = ref.matrix;
      var length = matrix.length;

      var ret = [];
      var lines = [];

      for (var i = length - 1; i >= 0; i--) {
        var array = matrix[i];

        var isEmpty = true;
        var isFull = true;

        for (var j = 0, l = array.length; j < l; j++) {
          array[j] ? isEmpty = false : isFull = false;
          if (!isEmpty && !isFull) {
            break;
          }
        }

        if (isFull) {
          lines.unshift(i);
        } else {
          ret.unshift(array);
        }
      }

      if (lines.length) {
        this.emit("clear:lines", lines);
      }

      this.matrix.matrix = padTop(ret, length);

      return lines;
    };
  };

  var DetectMixin = function DetectMixin(Tetris) {
    var proto = Tetris.prototype;

    proto._detectCollision = function () {
      var ref = this;
      var matrix = ref.matrix;
      var block = ref.block;
      // OVERFLOW
      var left = matrix.x;
      var right = matrix.x + matrix.col;
      var bottom = matrix.y + matrix.row;

      var ref$1 = block.coordinate;
      var x = ref$1.x;
      var y = ref$1.y;
      var ref$2 = block.shape;
      var margin = ref$2.margin;

      if (x + margin.left < left) {
        return true;
      }

      if (x + margin.left + margin.col > right) {
        return true;
      }

      // HIT

      if (y + margin.top + margin.row > bottom) {
        return true;
      }

      if (intersect$2(this.matrix.coordinate, this.block.coordinate)) {
        return true;
      }

      return false;
    };
  };

  var Tetris = function Tetris(options) {
    var this$1 = this;

    this._options = extend({
      matrix: new Matrix(),
      auto: true,
      speed: 500
    }, options);

    this._events = {};

    this._bind();
    this.reset();
    this.pause();

    this.on("hit", function () {
      var ref = this$1.block;
      var y = ref.y;
      var ref$1 = this$1.block.shape;
      var margin = ref$1.margin;

      if (y + margin.top < this$1.matrix.y) {
        this$1.fail();
      } else {
        this$1._next();
      }
    });
  };

  var prototypeAccessors = { graph: {} };

  prototypeAccessors.graph.get = function () {
    var ref = this.block;
    var block = ref.coordinate;
    var ref$1 = this.matrix;
    var matrix = ref$1.coordinate;

    return union$2(matrix, block);
  };

  Object.defineProperties(Tetris.prototype, prototypeAccessors);

  LoopMixin(Tetris);
  BlockMixin(Tetris);
  EventsMixin(Tetris);
  StateMixin(Tetris);
  KeyboardMixin(Tetris);
  MatrixMixin(Tetris);
  DetectMixin(Tetris);

  exports.Tetris = Tetris;
  exports.Shape = Shape;
  exports.Block = Block;
  exports.Matrix = Matrix;
  exports['default'] = Tetris;

  Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tetris = __webpack_require__(2);

exports.default = {
  name: 'tetris',

  data: function data() {
    return {
      tetris: null,
      graph: Array(15).fill(Array(15)),
      _pasued: false
    };
  },
  mounted: function mounted() {
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      this.tetris = new _tetris.Tetris({
        matrix: new _tetris.Matrix({
          row: 15,
          col: 15
        })
      });

      this.tetris.on('repaint', function (graph) {
        _this.graph = graph.array;
      });

      this.tetris.on('failed', function () {
        alert('Failed!');
      });

      this.tetris.start();
    },
    start: function start() {
      this._pasued = false;
      this.tetris.start();
    },
    pause: function pause() {
      if (this._pasued) {
        this._pasued = false;
        this.tetris.resume();
      } else {
        this._pasued = true;
        this.tetris.pause();
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _runtime = __webpack_require__(10);

var _runtime2 = _interopRequireDefault(_runtime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_runtime2.default.install({
  // When an update is ready, tell ServiceWorker to take control immediately:
  onUpdateReady: function onUpdateReady() {
    console.log('update ready');
    _runtime2.default.applyUpdate();
  },


  // Reload to get the new version:
  onUpdated: function onUpdated() {
    console.log('updated');
    location.reload();
  }
});

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(7)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(3),
  /* template */
  __webpack_require__(13),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "game"
  }, [_c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.graph), function(row) {
    return _c('li', [_c('ul', {
      staticClass: "col"
    }, _vm._l((row), function(col) {
      return _c('li', {
        staticClass: "rect",
        class: {
          'filled': col
        }
      }, [_c('div')])
    }))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "controls"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "loop"
  }, [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": _vm.pause
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("P")]), _vm._v(" "), _c('span', [_vm._v("pause")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.reset()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "drop",
    on: {
      "click": function($event) {
        _vm.tetris.drop()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("D")]), _vm._v(" "), _c('span', [_vm._v("Drop(space)")])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.rotate()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("O")]), _vm._v(" "), _c('span', [_vm._v("Rotate(up)")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-space-around"
  }, [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.left()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("L")]), _vm._v(" "), _c('span', [_vm._v("Left(left)")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.right()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("R")]), _vm._v(" "), _c('span', [_vm._v("Right(right)")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "flex-center",
    on: {
      "click": function($event) {
        _vm.tetris.down()
      }
    }
  }, [_c('a', {
    staticClass: "button"
  }, [_vm._v("D")]), _vm._v(" "), _c('span', [_vm._v("Down(down)")])])])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Powered by "), _c('a', {
    attrs: {
      "href": "//github.com/wasd-org/wasd-tetris",
      "target": "_blank"
    }
  }, [_vm._v("wasd-tetris")])])
}]}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ })
],[16]);


// WEBPACK FOOTER //
// client.b1d61852.js